import React from 'react';
import ChannelTile from '../ChannelTile';

const ChannelListings = ({ filteredChannels, handleSearch, isActive, handleChooseChannel, selectedChannel }) => {
  return (
    <>
      <div className="channel-view-controls">
        <div className="collection-search-container channel">
          <input 
            className="search-input" 
            type="text" 
            placeholder="Search for a channel here." 
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>

      <div className='row card-tiles-wrap'>
        {
          filteredChannels.map((channel) => (
            <div className='large-3 small-6 columns' key={channel.id}>
              <ChannelTile
                active={isActive(channel)}
                channel={channel}
                onClick={() => handleChooseChannel(channel)}
                selectedChannel={selectedChannel}
              />
            </div>
          ))
        }
      </div>
    </>
  );
};

export default ChannelListings;